import { Article } from '@/lib/articles';
import { Badge } from '../services/Badge';
import { Link } from 'react-router-dom';

interface BlogHeroProps {
	article: Article;
}

const BlogHero = ({ article }: BlogHeroProps) => {
	return (
		<Link to={`/blog/${article.id}`} className='block h-full'>
			<div className='w-full mb-12 animate-fade-in'>
				<div className='relative overflow-hidden rounded-xl shadow-xl group blog-card-hover'>
					<div className='absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent z-10'></div>

					<div className='relative h-[500px] overflow-hidden'>
						<img
							src={article.imageUrl}
							alt={article.title}
							className='w-full h-full object-cover object-center blog-card-image'
							loading='lazy'
						/>
					</div>

					<div className='absolute bottom-0 left-0 right-0 p-6 md:p-8 z-20 transform transition-transform duration-300 group-hover:translate-y-[-8px]'>
						<div className='flex flex-col space-y-4'>
							<Badge
								borderClassName='border-[#fbb040]'
								textClassName='text-white'
								text={article.category}
								className='max-w-[fit-content]'
							/>

							<h1 className='text-2xl sm:text-3xl md:text-4xl font-bold text-white text-balance leading-tight'>
								{article.title}
							</h1>

							<p className='text-gray-200 md:text-lg line-clamp-2 md:line-clamp-3 max-w-3xl text-balance'>
								{article.excerpt}
							</p>

							<div className='flex items-center text-gray-300 text-sm pt-2'>
								{/* <span className='font-medium'>{article.author}</span>
								<span className='mx-2'>•</span> */}
								<span>{article.published}</span>
								<span className='mx-2'>•</span>
								<span>{article.readTime} minutes</span>
							</div>
						</div>
					</div>

					<div className='absolute top-0 inset-x-0 h-40 bg-gradient-to-b from-black/50 to-transparent z-10 pointer-events-none'></div>
				</div>
			</div>
		</Link>
	);
};

export default BlogHero;
